<template>
    <div>
        <alert :alert-type="alertType" v-if="alertType !== null"></alert>
        <slot>
            <div v-if="renderFacebookLogin">
                <facebook-login
                    @authenticated="authenticated"
                    :facebook="facebook"
                    :redirect="redirect"
                ></facebook-login>
                <hr class="hr-text" data-content="OR">
            </div>
        </slot>
        <lookup-account
            @authenticated="authenticated"
            @clearEmail="reset"
            @error="setLoginErrorAlert"
            :find-or-create-ghost="!allowRegisterCheckout"
            @found="afterLookup"
            :redirect="redirect"
            :url-prefix="urlPrefix"
            v-if="lookupStage"
            v-model="email"
        ></lookup-account>
        <login
            @authenticated="authenticated"
            @clearEmail="reset"
            :email="email"
            @error="setLoginErrorAlert"
            :redirect="redirect"
            v-if="loginStage"
            :url-prefix="urlPrefix"
        ></login>
        <register
            @authenticated="authenticated"
            @clearEmail="reset"
            @error="setRegisterErrorAlert"
            :email="email"
            :redirect="redirect"
            :theme="theme"
            v-if="renderRegister"
            :url-prefix="urlPrefix"
        ></register>
        <hr class="hr-text" data-content="OR" v-if="renderRegister && renderGuestLogin">
        <guest-login
            @authenticated="authenticated"
            @error="setLoginErrorAlert"
            :email="email"
            :redirect="redirect"
            :url-prefix="urlPrefix"
            v-if="renderGuestLogin"
        ></guest-login>
    </div>
</template>

<script>
    import Alert from './Alert.vue';
    import FacebookLogin from './FacebookLogin.vue';
    import GuestLogin from "./GuestLogin.vue";
    import Login from './Login.vue';
    import LookupAccount from "./LookupAccount.vue";
    import Register from './Register.vue';

    import AlertTypes from './consts/alert_types';
    import Stages from './consts/stages';

    // require this line otherwise ['X-Requested-With'] = 'XMLHttpRequest' does not get set
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    export default {
        name: 'loginOrSignup',

        components: {
            Alert,
            FacebookLogin,
            GuestLogin,
            Login,
            LookupAccount,
            Register,
        },

        props: {
            defaultEmail: {
                default: '',
                required: false,
                type: String,
            },
            disableGuestLogin:{
                default: false,
                required: false,
                type: Boolean,
            },
            facebook: {
                default: null,
                required: false,
                type: Object,
            },
            participantUserAuthenticationStrategy: {
                default: '',
                type: String
            },
            redirect: {
                default: '',
                required: false,
                type: String,
            },
            theme: {
                default: 'bs4',
                type: String,
            },
            urlPrefix: {
                default: '',
                type: String,
            },
        },

        data() {
            return {
                alertType: null,
                email: this.defaultEmail,
                loginError: false,
                registerError: false,
                stage: Stages.LOOKUP_ACCOUNT,
            }
        },

        computed: {
            allowGuestCheckout() {
                return this.disableGuestLogin
                    ? false
                    : ['guest_login', 'guest_register_login'].indexOf(this.participantUserAuthenticationStrategy) > -1;
            },
            allowRegisterCheckout() {
                return ['guest_register_login', 'register_login'].indexOf(this.participantUserAuthenticationStrategy) > -1;
            },
            loginStage() {
                return this.stage === Stages.LOGIN;
            },
            lookupStage() {
                return this.stage === Stages.LOOKUP_ACCOUNT;
            },
            registerOrGhostStage() {
                return this.stage === Stages.REGISTER_OR_GHOST;
            },
            renderFacebookLogin() {
                return this.facebook && this.lookupStage && !this.allowGuestCheckout;
            },
            renderGuestLogin() {
                return this.registerOrGhostStage && this.allowGuestCheckout;
            },
            renderRegister() {
                return this.registerOrGhostStage && this.allowRegisterCheckout;
            },
        },

        methods: {
            afterLookup(success) {
                if (success) {
                    Object.assign(this, {
                        alertType: AlertTypes.ACCOUNT_FOUND,
                        stage: Stages.LOGIN,
                    });

                    return;
                }

                Object.assign(this, {stage: Stages.REGISTER_OR_GHOST});
            },
            authenticated(user) {
                this.alertType = null;

                this.$emit('authenticated', user);
            },
            reset() {
                Object.assign(this, {
                    alertType: null,
                    email: '',
                    stage: Stages.LOOKUP_ACCOUNT,
                });
            },
            setLoginErrorAlert() {
                this.alertType = AlertTypes.LOGIN_ERROR;
            },
            setRegisterErrorAlert() {
                this.alertType = AlertTypes.REGISTER_ERROR;
            },
        },
    }
</script>

<style lang="scss">
.hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    opacity: .5;

    &:before {
        content: '';
        // use the linear-gradient for the fading effect
        // use a solid background color for a solid bar
        background: linear-gradient(to right, transparent, #818078, transparent);
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
    }

    &:after {
        content: attr(data-content);
        position: relative;
        display: inline-block;
        color: black;

        padding: 0 .5em;
        line-height: 1.5em;
        // this is really the only tricky part, you need to specify the background color of the container element...
        color: #818078;
        background-color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/LoginOrSignup.vue